import './SystemPasswordOnboardingHeader.css';

import React from 'react';
import { VentionLogo } from '@src/assets';
import { RemoteAccessStatus, WifiConnectionStatus } from '@src/components';

interface SystemPasswordOnboardingHeaderProps {
  title: string
}

export const SystemPasswordOnboardingHeader = ({ title }: SystemPasswordOnboardingHeaderProps): JSX.Element => {
  return (
    <div id="system_password_onboarding_header">
      <div id="system_password_onboarding_header_controls">
        <VentionLogo />
        <div id="system_password_onboarding_header_connectivity">
          <RemoteAccessStatus />
          <WifiConnectionStatus />
        </div>
      </div>
      <div id="system_password_onboarding_header_title">{title}</div>
    </div>
  );
};
